import { useToast as useToastContext } from '../contexts/ToastContext';

/**
 * Hook to access toast notifications
 * Re-exports the toast context hook for convenience
 */
export const useToast = useToastContext;
